<template>
  <v-app id="inspire" light :style=inspiredStyle>
    <v-content id="container">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
  },

  data() {
    return {
    }
  },

  computed: {
    inspiredStyle: function() {
      let style = "background: #FF000000;"
      if (window.isMobile)
        style += "overflow-y: scroll; height: 100%;"
      return style;
    }
  },

  methods: {
  },

  mounted() {
    // do not use it, change the style of inspire with a computed instead...
    /*if (window.isMobile) {
      document.getElementById("inspire").className = "scrollable";
    }*/
  }
}
</script>

<style>
.application {
  font-family: "Montserrat";
}

.scrollable {
  height: 100%;
  overflow-y: scroll;
}
</style>
